import { FC, useEffect, useRef } from 'react';
import Stats from 'stats.js';
import './Stats.css';

const StatsComponent: FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const statsRef = useRef<Stats>();

  useEffect(() => {
    if (!containerRef.current) return;

    // Create stats instance
    const stats = new Stats();
    statsRef.current = stats;

    // Add panels
    stats.showPanel(0); // FPS
    stats.showPanel(1); // MS
    stats.showPanel(2); // MB

    // Add to container
    containerRef.current.appendChild(stats.dom);

    // Start animation loop
    const animate = () => {
      if (statsRef.current) {
        statsRef.current.update();
      }
      requestAnimationFrame(animate);
    };
    animate();

    // Cleanup
    return () => {
      if (containerRef.current && statsRef.current) {
        containerRef.current.removeChild(statsRef.current.dom);
      }
    };
  }, []);

  return <div ref={containerRef} className="stats-container" />;
};

export default StatsComponent; 